<template>
    <div id="content" v-show="!loading">
        <popup v-show="hasPopupWithSpecification"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
          <div class="inner">
            <p class="paging">
              <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
            </p>
            <p class="buttons">
              <a v-if="!entity.active && $_updateActionAllowed"
                 class="btn btn_action btn_grey btn_enable"
                 :title="'Aktivovat' | translate"
                 @click.prevent.stop="updateEntityActive('active', true)"
                 v-translate>Aktivovat</a>
              <a v-if="entity.active  && $_updateActionAllowed"
                 class="btn btn_action btn_grey btn_disable"
                 :title="'Deaktivovat' | translate"
                 @click.prevent.stop="updateEntityActive('active', false)"
                 v-translate>Deaktivovat</a>
            </p>
            <h1>{{entity.name}}</h1>
          </div>

            <div class="responsiveTabs">
                <ul class="tabs">
                    <li :class="getActiveTabClass(Tabs.settings)">
                        <a @click.prevent.stop="activateTab(Tabs.settings)" v-translate>Vlastnosti</a>
                    </li>
                    <li :class="getActiveTabClass(Tabs.users)" v-if="$_loggedUser_action_allowed('users')">
                        <a @click.prevent.stop="activateTab(Tabs.users)" v-translate>Uživatelé</a>
                    </li>
                </ul>
                <div class="tabs_content" v-show="isActiveTab(Tabs.settings)">
                    <operator-basic-info
                            :entity="entity"
                            :all-brands="allBrands"
                            :all-business-models="allBusinessModels"
                            :is-operator-my-operator="isOperatorMyOperator"
                            :upload-ready="uploadReady"
                            :is-editable="$_updateActionAllowed"
                            :selected-file="selectedFile"
                            @selected-file="selectedFile = arguments[0]"
                            @delete-image="deleteImage"
                            ref="operatorbasicinforef"
                    ></operator-basic-info>
                    <operator-contact
                        :entity="entity"
                        :is-editable="$_updateActionAllowed"
                    >
                    </operator-contact>
                    <operator-licence
                            :entity="entity"
                            :is-editable="$_updateActionAllowed"
                            :subscriberTypeOptions="subscriberTypes"
                            :geoblockingCountryCodes="geoblockingCountryCodes"
                            :businessModelIncludedDeviceCount="businessModelIncludedDeviceCount"
                            :businessModelIncludedFirstscreenDeviceCount="businessModelIncludedFirstscreenDeviceCount"
                            ref="operatorconfigurationref"
                    ></operator-licence>
                    <VodProviders
                        v-if="entity.id"
                        :entity="entity"
                        :id-operator="entity.id"
                        :id-business-model="entity.id_business_model"
                        :is-editable="$_updateActionAllowed"
                        ref="vodprovidersref"
                    >
                    </VodProviders>
                    <AdvertisingProviders
                        :entity="entity"
                        :advertisingProviders="advertisingProviders"
                        :is-editable="$_updateActionAllowed"
                    />
                    <form-buttons
                            v-if="$_updateActionAllowed"
                            :module-name="moduleName"
                            :custom-submit-text="'Uložit vlastnosti' | translate"
                            @submit-form="submitForm"
                    ></form-buttons>
                  <form-buttons
                      v-else-if="$_loggedUser_action_allowed('operators', 'read', 'OWN')"
                      :module-name="moduleName"
                      :custom-submit-text="'Uložit vlastnosti' | translate"
                      @submit-form="saveOperatorSettings"
                  ></form-buttons>
                </div>
                <div class="tabs_content" v-show="isActiveTab(Tabs.users)" v-if="$_loggedUser_action_allowed('users')">
                    <user-list-table
                            :operator-id="this.$route.params.id"
                            :read-only-mode="!$_updateActionAllowed"
                    ></user-list-table>
                    <section class="buttons">
                        <p>
                            <router-link
                                    :to="{ name: moduleName }"
                                    class="btn btn_back btn_seznam"
                                    v-translate>Seznam
                            </router-link>
                        </p>
                    </section>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
	import Popup from "@/components/common/Popup"
	import FormButtons from "@/components/common/FormButtons"
	import OperatorBasicInfo from "@/components/views/operators/settings/OperatorBasicInfo"
	import OperatorContact from "@/components/views/operators/settings/OperatorContact"
	import OperatorLicence from "@/components/views/operators/settings/OperatorLicence"
	import UserListTable from "@/components/views/operators/UserListTable"

	import userSettings from "@/components/mixins/user-settings"
	import detailActions from "@/components/mixins/detail-actions"
	import operators from "@/components/views/operators/mixins/operators"
	import {AUTH_OPERATOR_UPDATE} from "@/store/mutation-types"
  import AdvertisingProviders from "./settings/AdvertisingProviders.vue";
  import VodProviders from "./settings/VodProviders.vue";

	export const Tabs = Object.freeze({
		settings: "settings",
		users: "users"
	})

	export default {
		name: "OperatorDetail",
		components: {
      AdvertisingProviders,
			FormButtons,
			OperatorLicence,
			OperatorContact,
			OperatorBasicInfo,
			UserListTable,
			Popup,
      VodProviders
		},
		mixins: [detailActions, operators, userSettings],
		data() {
			return {
				Tabs,
				loading: true,
			}
		},
		computed: {
			hasPopupWithSpecification() {
				return this.hasPopup && this.getPopupSpecification === 'operator'
			},
			entityId() {
				return this.entity.id
			},
			isOperatorMyOperator() {
				return String(this.entity.id) === String(this.$store.getters.operatorId)
			},
		},
		created(OperatorService, AdvertisingProviderService) {
			this.entityService = OperatorService
			this.advertisingProviderService = AdvertisingProviderService
			this.createdInit()
			if (this.$route.params.activeTab && Object.values(Tabs).indexOf(this.$route.params.activeTab) > -1) {
				this.activateTab(this.$route.params.activeTab)
			}
		},
		beforeDestroy() {
			this.activateTab(Tabs.settings)
		},
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(data => {
						this.emptyMessage()

						if (!this._.has(data[this.entityName], 'contact')) {
							data[this.entityName]['contact'] = this.operatorContact
						}

						this.entity = data[this.entityName]
						this._afterGetEntityActions(data)
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
			_afterGetEntityActions(data) {
				this.allBrands = this.prependWithUndefinedOptions(data['all_brands'])
				this.allBusinessModels = this.prependWithUndefinedOptions(data['all_business_models'])
				this.subscriberTypes = data['subscriber_types']
        this.geoblockingCountryCodes = data['geoblocking_country_codes'];
        this.businessModelIncludedDeviceCount = data['business_model_included_device_count'];
        this.businessModelIncludedFirstscreenDeviceCount = data['business_model_included_firstscreen_device_count'];
        this.$refs['vodprovidersref'].init();
        let businessModel = this.allBusinessModels.filter(businessModel => (businessModel.id == this.entity.id_business_model))[0]
        this.advertisingProviderService.getEntities(businessModel.advertising_providers_order && { id: businessModel.advertising_providers_order.join(',') })
            .then((data) => {
              this.advertisingProviders = data['advertisingProviders']
            })
			},
      updateEntity(params, redirect = false) {
        let preProcessedParams = this._beforeUpdateEntityActions({...params})
        return this.entityService.updateEntity(this.entity.id, this.filterFormParams(preProcessedParams))
            .then(() => {
              Promise.resolve(this.uploadLogo(this.entity.id))
                  .then(() => {
                    if (redirect === true) {
                      this.redirect(this.moduleName)
                    } else {
                      this._resetFields()
                      this.emptyMessage()
                      this.setSuccessMessage()
                      this.getEntity()
                          .then(() => {
                            this._afterUpdateEntityActions()
                          })
                    }
                  })
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      },
			_afterUpdateEntityActions() {
				this.reset()
				if (Number(this.entity.id) === Number(this.$_loggedUser_operatorId)) {
					this.entityService.getOperator()
						.then((data) => {
							this.$store.dispatch(AUTH_OPERATOR_UPDATE, data)
						})
				}
			},
      executePopupAction(value) {
        if (value === true) {
          if (this.getPopupAction === 'delete') {
            this.deleteEntity(false)
          }
          if (this.getPopupAction === 'delete-image') {
            this.deleteImage(false)
          }
        }
        this.hidePopup()
      },
			deleteEntity(showPopup = true) {
				if (showPopup) {
					this.showPopup(null, 'delete', 'delete', 'operator')
				} else {
					this.entityService.deleteEntity(this.entity.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
						.then(() => {
							this.reloadOperatorsSimpleList()
							this.$router.push({name: this.moduleName})
						})
						.catch(function (error) {
							this.setErrorMessage(error['error_message'])
						}.bind(this))
				}
			},
      saveOperatorSettings(){
        this.entityService.updateOperatorSettings(this.entity.id, {
          selfservice_allowed: this.entity.selfservice_allowed,
          selfservice_url: this.entity.selfservice_url,
          selfservice_api_key: this.entity.selfservice_api_key,
          vod_allow_purchase_unprocessed_video: this.entity.vod_allow_purchase_unprocessed_video,
        })
            .then(() => {
              this._resetFields()
              this.emptyMessage()
              this.setSuccessMessage()
              this.getEntity()
                  .then(() => {
                    this._afterUpdateEntityActions()
                  })
            })
            .catch(function (error) {
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      },
      deleteImage(showPopup = true) {
        if (this.selectedFile) {
          this.selectedFile = null
          this.uploadReady = false
          this.$nextTick(() => {
            this.uploadReady = true
          })
          return null
        }
        if (showPopup) {
          this.showPopup(null, 'delete-image', 'delete-image', 'operator')
        } else {
          this.entityService.deleteLogo(this.entity.id)
              .then(() => {
                this._resetFields()
                this.emptyMessage()
                this.setSuccessMessage()
                this.getEntity()
                    .then(() => {
                      this._afterUpdateEntityActions()
                    })
              })
              .catch(function (error) {
                this.setErrorMessage(error['error_message'])
              }.bind(this))
        }
      },
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/OperatorDetail.vue